const TOKEN_KEY = "rt-auth-token";
const REMEMBER_KEY = "rt-remember";
const EMAIL_KEY = "rt-remember-email";

/**
 * Auth token persistence for "remember me".
 *
 * Remembered  -> localStorage, so the session survives closing the browser.
 * Not remembered -> sessionStorage, so it dies with the tab. That is the
 * point of the checkbox: on a shared machine, leaving the box unticked must
 * not leave a usable token behind on disk.
 */
export function readToken() {
  return (
    localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || ""
  );
}

export function writeToken(token, remember) {
  // Always clear both first so a token can never linger in the other store.
  clearToken();
  if (!token) return;

  if (remember) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(REMEMBER_KEY, "1");
  } else {
    sessionStorage.setItem(TOKEN_KEY, token);
  }
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}

/** Whether the last successful sign-in asked to be remembered. */
export function readRemember() {
  return localStorage.getItem(REMEMBER_KEY) === "1";
}

/** The remembered address, so the email field is pre-filled next visit. */
export function readRememberedEmail() {
  return localStorage.getItem(EMAIL_KEY) ?? "";
}

export function writeRemembered(remember, email) {
  if (remember) {
    localStorage.setItem(REMEMBER_KEY, "1");
    localStorage.setItem(EMAIL_KEY, email ?? "");
  } else {
    localStorage.removeItem(REMEMBER_KEY);
    localStorage.removeItem(EMAIL_KEY);
  }
}
